import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbookLineageCountsFragmentGql } from './WorkbookLineageCountsFragmentGql';

export const WorkbookLineageCountsFilteredByFieldQueryGql: DocumentNode = gql`
query WorkbookLineageCountsFilteredByFieldQuery(
  $workbookVizportalUrlId: String!,
  $selectedEmbeddedDatasourceId: ID!,
  $selectedFieldId: ID!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    embeddedDatasources(filter: { id: $selectedEmbeddedDatasourceId }) {
      filteredFieldsConnection: fieldsConnection(filter: {id: $selectedFieldId}) {
        nodes {
          name
          upstreamDatabasesConnection {
            totalCount
          }
          upstreamTablesConnection {
            totalCount
          }
          upstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
            totalCount
          }
          upstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
            totalCount
          }
          upstreamFlowsConnection {
            totalCount
          }
          upstreamDatasourcesConnection {
            totalCount
          }
          sheetsConnection {
            totalCount
          }
          dashboardsConnection: downstreamDashboardsConnection {
            totalCount
          }
          downstreamMetricsConnection {
            totalCount
          }
          downstreamOwnersConnection {
            totalCount
          }
        }
      }
    }
    ...WorkbookLineageCountsFragment
  }
}
${WorkbookLineageCountsFragmentGql}
`;
